export enum FeatureProducts {
  Available = "web_products",
  CreateProducts = "product_creation",
  MassiveUpload = "web_massive_upload",
  ProductImages = "image_product_creation",
  ExportInventory = "export_inventory",
  SkuConfiguration = "sku_configuration",
  ProductsAi = "ai_product",
}
